/**
 * Quantyoo Slider
 *
 * @see https://glidejs.com/
 * @version 1.0.0
 * @copyright 2019 SEDA.digital GmbH & Co. KG
 */

import Glide from '@glidejs/glide';

let buttonPrev = document.querySelector('.glide__arrows .slider-nav-arrow--left');
let buttonNext = document.querySelector('.glide__arrows .slider-nav-arrow--right');

if (document.body.contains(buttonPrev) && document.body.contains(buttonNext)) {
    const glide = new Glide('.glide', {
        type: 'carousel',
        startAt: 0,
        perView: 6,
        breakpoints: {
            640: {
                perView: 3
            }
        }
    }).mount()

    buttonNext.addEventListener("click", function(){
        glide.go('>');
    });
    buttonPrev.addEventListener("click", function(){
        glide.go('<');
    });
}
